window.panzoom = require('panzoom')
